export const ReportCategoryType = {
  MAINTENANCE: 'MAINTENANCE',
  DISORDER: 'DISORDER',
  ALL: 'ALL'
};

export const ReportCategoryLevel = {
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  FINISH: 'FINISH'
};

export default class ReportCategory {
  constructor(
    id = null,
    title = '',
    color = '#409EFF',
    colorCSS = 'color: #409EFF;',
    priority = 0,
    visibilityDurationInMillis = 86400000, // 24 hours default
    type = ReportCategoryType.MAINTENANCE,
    level = ReportCategoryLevel.CREATE,
    tenantId = null,
    tenant = null,
    reportsAssignedCount = 0
  ) {
    this.id = id;
    this.title = title;
    this.color = color;
    this.colorCSS = colorCSS;
    this.priority = priority;
    this.visibilityDurationInMillis = visibilityDurationInMillis;
    this.type = type;
    this.level = level;
    this.tenantId = tenantId;
    this.tenant = tenant;
    this.reportsAssignedCount = reportsAssignedCount;
  }

  /**
   * Create a ReportCategory from a raw object
   * @param {Object} data - Raw data from API
   * @returns {ReportCategory} A new ReportCategory instance
   */
  static fromJson(data) {
    return new ReportCategory(
      data.id,
      data.title,
      data.color,
      data.colorCSS,
      data.priority,
      data.visibilityDurationInMillis,
      data.type,
      data.level,
      data.tenantId,
      data.tenant,
      data.reportsAssignedCount,
    );
  }

}
